import React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Alert, AlertDescription } from '@frontend/shadcn/components/ui/alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { StyledHashtagIcon } from '../../../components/icons/styled-hashtag-icon';

interface InstagramCreatorSearchEmptyStateProps {
  hasSearchFilters?: boolean;
  onClearFilters?: () => void;
}

export const InstagramCreatorSearchEmptyState: React.FC<InstagramCreatorSearchEmptyStateProps> = ({
  hasSearchFilters = false,
  onClearFilters,
}) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-10 bg-white rounded-2xl">
      <StyledHashtagIcon />
      <div className="flex flex-col items-center gap-1.5 mb-6 w-full">
        <h3 className="text-base font-medium leading-7 text-gray-900 m-0">
          No matches just yet! 👀
        </h3>
        <p className="text-sm leading-6 text-gray-600 m-0">
          Try adjusting or removing a few filters to discover more amazing creators.
        </p>
      </div>
      {hasSearchFilters && onClearFilters && (
        <Button onClick={onClearFilters} variant="outline">
          Clear Filters
        </Button>
      )}
      <Alert className="mt-4 rounded-xl bg-[#FBF4DB] w-fit max-w-full">
        <AlertDescription className="text-sm text-gray-600 m-0 flex items-center gap-2">
          <FontAwesomeIcon icon={faLightbulb} className="text-[#E2AB23]" />
          <span>Tip: Try widening <span className="font-bold">"Follower Count"</span> or <span className="font-bold">"Engagement Rate"</span> to discover more creators.</span>
        </AlertDescription>
      </Alert>
    </div>
  );
};
